module.exports = __webpack_public_path__ + "img/delete.f9f75086.png";